export const DISK_CLEANUP_EXTENSION_GROUPS = [
  { label: "Imagens", extensions: [".png", ".jpeg", ".jpg", ".gif", ".webp"] },
  { label: "Vídeos", extensions: [".mp4", ".mov"] },
  { label: "Áudio", extensions: [".mp3", ".ogg", ".wav"] },
  { label: "Documentos", extensions: [".pdf"] },
  { label: "Arquivos compactados", extensions: [".zip", ".rar", ".exe"] },
];

export const ALL_DISK_CLEANUP_EXTENSIONS = DISK_CLEANUP_EXTENSION_GROUPS.flatMap(
  (group) => group.extensions
);

export const normalizeSelectedExtensions = (extensions) => {
  if (!Array.isArray(extensions) || extensions.length === 0) {
    return [...ALL_DISK_CLEANUP_EXTENSIONS];
  }

  const allowed = new Set(ALL_DISK_CLEANUP_EXTENSIONS.map((ext) => ext.toLowerCase()));
  const normalized = extensions
    .filter((ext) => typeof ext === "string" && ext.length > 0)
    .map((ext) => {
      const lower = ext.toLowerCase();
      return lower.startsWith(".") ? lower : `.${lower}`;
    })
    .filter((ext) => allowed.has(ext));

  return normalized.length > 0 ? normalized : [...ALL_DISK_CLEANUP_EXTENSIONS];
};

export const formatExtensionLabel = (ext) => ext.replace(".", "").toUpperCase();
